// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/evil_of_frankenstein/EvilofFrankenstein.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Define the font-face */
@font-face {
  font-family: navFont;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* Header styling */
.Header {
  margin: 0;
  background-color: rgba(65, 0, 0, 0.301);
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  flex-direction: column;
  box-shadow: 0px 10px 10px 5px rgb(65, 0, 0);
  margin-bottom: 30px;
}

/* Logo styling */
.headerLogo {
  width: 60px;
  height: 67px;
  border-radius: 50%; /* Make the logo circular */
  border: 5px double rgb(100, 0, 0);
}

/* Navbar styling */
.navbar {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 5px solid rgba(116, 1, 1, 0.466);
  border-bottom: 5px solid rgba(36, 0, 0, 0.466);
  background-color: rgba(179, 138, 64, 0.692);
  font-family: navFont;
  font-size: x-large;
  position: sticky;
}

/* Navbar list styling */
.unorderedListNavbar {
  list-style: none;
  display: flex;
  justify-content: space-around;
  padding: 0;
}

/* Navbar list item styling */
.unorderedListNavbar li {
  margin: 0 10px;
  transition: color 0.5s, background-color 0.5s, box-shadow 0.5s;
  text-transform: uppercase;
}

/* Navbar list item hover styling */
.unorderedListNavbar li:hover {
  color: #ff0000; /* Hover color (red) */
  background-color: #19cc01;
  box-shadow: 0px 0px 10px 5px rgba(21, 255, 0, 0.856);
}

/* Media Query for Tablets */
@media screen and (min-width: 768px) {
  /* Adjust header styling for tablets */
  .Header {
    height: 150px;
  }

  /* Adjust logo styling for tablets */
  .headerLogo {
    width: 80px;
    height: 90px;
  }

  /* Adjust navbar styling for tablets */
  .navbar {
    height: 40px;
  }

  /* Adjust font-size for tablets */
  .navbar {
    font-size: 1.5rem;
  }
}

/* Media Query for Notebooks and Monitors */
@media screen and (min-width: 1024px) {
  /* Adjust header styling for notebooks and monitors */
  .Header {
    flex-direction: row;
    height: 200px;
  }

  /* Adjust logo styling for notebooks and monitors */
  .headerLogo {
    width: 100px;
    height: 112px;
    position: absolute;
    z-index: 2;
  }

  /* Adjust navbar styling for notebooks and monitors */
  .navbar {
    height: 50px;
  }

  /* Adjust font-size for notebooks and monitors */
  .navbar {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.component.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,4CAAqE;AACvE;;AAEA,mBAAmB;AACnB;EACE,SAAS;EACT,uCAAuC;EACvC,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE,2BAA2B;EAC/C,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,8CAA8C;EAC9C,2CAA2C;EAC3C,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,8DAA8D;EAC9D,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,cAAc,EAAE,sBAAsB;EACtC,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA,4BAA4B;AAC5B;EACE,sCAAsC;EACtC;IACE,aAAa;EACf;;EAEA,oCAAoC;EACpC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,sCAAsC;EACtC;IACE,YAAY;EACd;;EAEA,iCAAiC;EACjC;IACE,iBAAiB;EACnB;AACF;;AAEA,2CAA2C;AAC3C;EACE,qDAAqD;EACrD;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA,mDAAmD;EACnD;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;EACZ;;EAEA,qDAAqD;EACrD;IACE,YAAY;EACd;;EAEA,gDAAgD;EAChD;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Define the font-face */\n@font-face {\n  font-family: navFont;\n  src: url('/public/fonts/evil_of_frankenstein/EvilofFrankenstein.ttf');\n}\n\n/* Header styling */\n.Header {\n  margin: 0;\n  background-color: rgba(65, 0, 0, 0.301);\n  width: 100%;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  box-shadow: 0px 10px 10px 5px rgb(65, 0, 0);\n  margin-bottom: 30px;\n}\n\n/* Logo styling */\n.headerLogo {\n  width: 60px;\n  height: 67px;\n  border-radius: 50%; /* Make the logo circular */\n  border: 5px double rgb(100, 0, 0);\n}\n\n/* Navbar styling */\n.navbar {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-top: 5px solid rgba(116, 1, 1, 0.466);\n  border-bottom: 5px solid rgba(36, 0, 0, 0.466);\n  background-color: rgba(179, 138, 64, 0.692);\n  font-family: navFont;\n  font-size: x-large;\n  position: sticky;\n}\n\n/* Navbar list styling */\n.unorderedListNavbar {\n  list-style: none;\n  display: flex;\n  justify-content: space-around;\n  padding: 0;\n}\n\n/* Navbar list item styling */\n.unorderedListNavbar li {\n  margin: 0 10px;\n  transition: color 0.5s, background-color 0.5s, box-shadow 0.5s;\n  text-transform: uppercase;\n}\n\n/* Navbar list item hover styling */\n.unorderedListNavbar li:hover {\n  color: #ff0000; /* Hover color (red) */\n  background-color: #19cc01;\n  box-shadow: 0px 0px 10px 5px rgba(21, 255, 0, 0.856);\n}\n\n/* Media Query for Tablets */\n@media screen and (min-width: 768px) {\n  /* Adjust header styling for tablets */\n  .Header {\n    height: 150px;\n  }\n\n  /* Adjust logo styling for tablets */\n  .headerLogo {\n    width: 80px;\n    height: 90px;\n  }\n\n  /* Adjust navbar styling for tablets */\n  .navbar {\n    height: 40px;\n  }\n\n  /* Adjust font-size for tablets */\n  .navbar {\n    font-size: 1.5rem;\n  }\n}\n\n/* Media Query for Notebooks and Monitors */\n@media screen and (min-width: 1024px) {\n  /* Adjust header styling for notebooks and monitors */\n  .Header {\n    flex-direction: row;\n    height: 200px;\n  }\n\n  /* Adjust logo styling for notebooks and monitors */\n  .headerLogo {\n    width: 100px;\n    height: 112px;\n    position: absolute;\n    z-index: 2;\n  }\n\n  /* Adjust navbar styling for notebooks and monitors */\n  .navbar {\n    height: 50px;\n  }\n\n  /* Adjust font-size for notebooks and monitors */\n  .navbar {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
